import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Manager } from '../models/Manager';
import { ManagerService } from '../services/manager.service';

@Component({
  selector: 'toolbar',
  templateUrl: 'toolbar.component.html',
  styleUrls: ['toolbar.component.css']
})
export class ToolbarComponent {

  manager!: Manager;

  constructor(private router: Router, private managerService: ManagerService) { }

  ngOnInit() {
    this.manager = this.managerService.getLoggedUser();
  }

  get loggedUserName() {
    return this.manager?.name
  }

  logo() {
    this.router.navigate(['/main']);
  }
}